import React, { useEffect, useState } from "react";

export default function SplashScreen() {
  const [offline, setOffline] = useState(() => typeof navigator !== "undefined" && !navigator.onLine);
  const [visible, setVisible] = useState(() => {
    const isOffline = typeof navigator !== "undefined" && !navigator.onLine;
    return isOffline || !sessionStorage.getItem("nexora-splash-seen");
  });
  const [step, setStep] = useState(1);

  useEffect(() => {
    const sync = () => {
      const nextOffline = !navigator.onLine;
      setOffline(nextOffline);
      if (nextOffline) {
        setStep(1);
        setVisible(true);
      }
    };
    window.addEventListener("online", sync);
    window.addEventListener("offline", sync);
    return () => {
      window.removeEventListener("online", sync);
      window.removeEventListener("offline", sync);
    };
  }, []);

  useEffect(() => {
    if (!visible) return;
    if (step >= 6) {
      const done = setTimeout(() => {
        sessionStorage.setItem("nexora-splash-seen", "1");
        setVisible(false);
      }, 320);
      return () => clearTimeout(done);
    }
    const timer = setTimeout(() => {
      setStep((current) => Math.min(6, current + 1));
    }, 360);
    return () => clearTimeout(timer);
  }, [step, visible]);

  useEffect(() => {
    if (!visible) return undefined;
    const hardLimit = setTimeout(() => {
      sessionStorage.setItem("nexora-splash-seen", "1");
      setVisible(false);
    }, 3200);
    return () => clearTimeout(hardLimit);
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[5000] flex items-center justify-center overflow-hidden bg-[#03060d] text-white">
      <div className="absolute inset-0 bg-premium-grad" />
      <div className="relative z-10 flex w-full max-w-sm flex-col items-center px-6 text-center">
        <img src="/nexora-cab.png" alt="Nexora Cab" className="h-28 w-28 rounded-3xl object-cover shadow-[0_0_60px_rgba(0,212,255,0.38)]" />
        <div className="mt-5 font-heading text-3xl font-black">NEXORA<span className="text-primary">-cab</span></div>
        <div className="mt-1 text-xs font-bold uppercase tracking-[0.22em] text-cyan-100/75">Votre trajet, notre priorite</div>
        <div className="relative mt-10 h-20 w-full overflow-hidden rounded-full border border-white/10 bg-white/5">
          <div className="absolute left-0 right-0 top-1/2 h-px bg-gradient-to-r from-transparent via-primary to-transparent" />
          <div className="splash-car absolute top-1/2 -translate-y-1/2">
            <div className="relative h-12 w-24">
              <div className="absolute bottom-3 left-2 h-8 w-20 rounded-t-[28px] rounded-b-xl bg-gradient-to-r from-primary to-secondary shadow-[0_0_30px_rgba(0,212,255,0.5)]" />
              <div className="absolute bottom-2 left-5 h-4 w-4 rounded-full border-4 border-white/80 bg-black" />
              <div className="absolute bottom-2 right-5 h-4 w-4 rounded-full border-4 border-white/80 bg-black" />
              <div className="absolute bottom-8 left-10 h-4 w-8 rounded-t-xl bg-black/45" />
            </div>
          </div>
        </div>
        <div className="mt-5 text-xs text-muted-foreground">
          {offline ? "Connexion indisponible, ouverture du mode hors ligne" : "Chargement des publications et notifications"}
        </div>
        <div className="mt-3 flex items-center justify-center gap-1.5" aria-label={`Chargement ${step} sur 6`}>
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <span
              key={item}
              className={`h-2 w-2 rounded-full transition-all duration-200 ${
                item <= step ? "bg-primary shadow-[0_0_12px_rgba(0,212,255,0.85)]" : "bg-white/15"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
